module.exports = __webpack_public_path__ + "static/img/TA.3ec8a593.svg";